// @flow

import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FieldWrapper } from 'speed-js-react-web';
import { Box } from 'grommet';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';

type Props = {
    onClose: () => void,
    object: Object,
};

const NotificationTypeAddContent = (props: Props) => {
    const {
        onClose, object,
    } = props;
    const [val, setValue] = React.useState(null);
    const choices = [
        <FormattedMessage id="choice-channel" defaultMessage="channel" />,
        <FormattedMessage id="choice-scope" defaultMessage="scope" />,
    ];
    const handleChooseChannelOrScope = (value: string) => {
        // choose channel or scope
        setValue(value);
    };
    const renderChannelOrScopeSelect = () => (
        <FieldWrapper label={(
            <FormattedMessage
                id="notification-type-content"
                defaultMessage="Content"
            />
        )}
        >
            <BaseSelect
                emptyLabel={(
                    <FormattedMessage
                        id="notification-type-content-select"
                        defaultMessage="Select content"
                    />
                )}
                choices={choices}
                value={val}
                onChange={handleChooseChannelOrScope}
            />
        </FieldWrapper>
    );
    return (
        <Box height="100%" pad={{ bottom: 'xsmall' }}>
            <Box height="12px" flex={{ shrink: 0 }} />
            <Box pad={{ horizontal: 'small' }}>
                {renderChannelOrScopeSelect()}
            </Box>
            <Box height="12px" flex={{ shrink: 0 }} />
            {val ? (
                <ApiForm
                    key={choices[val].props.defaultMessage === 'channel'
                        ? 'notificationTypeChannel'
                        : 'notificationTypeScope'
                    }
                    resourceName={choices[val].props.defaultMessage === 'channel'
                        ? 'notificationTypeChannel'
                        : 'notificationTypeScope'
                    }
                    onSave={() => onClose(true)}
                    onClose={() => onClose()}
                    initial={{ notification_type: object.id }}
                    excludeFields={['notification_type']}
                />
            ) : null}
        </Box>
    );
};

export default injectIntl(NotificationTypeAddContent);
